import styled, { css } from 'styled-components';
import FeatureDemandBanner from './FeatureDemandBannerTemplate';
import { rem } from 'polished';

export const FeatureDemandBannerStyled = styled(FeatureDemandBanner)`
    height: ${rem(300)};
    background-position: center;
    background-size: cover;

    display: flex;
    align-items: flex-end;
    padding: ${rem(24)};

    ${({ isConfigPage }) =>
        isConfigPage &&
        css`
            width: 100%;
            margin-bottom: ${rem(30)};
        `}

    ${({ isBasketPage }) =>
        isBasketPage &&
        css`
            width: calc(100% - ${rem(20)});
            margin-top: ${rem(30)};
        `}

    .title {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
    }

    .link {
        background: none;
        border: none;
        padding: 0;
        margin-top: ${rem(20)};
    }
`;
